import axios from '../../util/Axios';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ArmsMobile } from './ArmsMobile';

export function ArmsChartsPage() {
  const [arms, setArms] = useState(null);
  const [error, setError] = useState(false);

  let { testId } = useParams();

  useEffect(() => {
    axios('/strokeTests/armMovements/' + testId).then((resp) => {
      const armsData = resp.data;
      setArms(armsData);
    })
    .catch(() => {
      setError(true);
    });
  }, [testId]);

  
  if (!arms && error) return <p style={{ textAlign: 'center'}}>Error occurred while fetching arms data!</p>;
  
  if (!arms) return '';

  return (
    arms.armMovement || arms.armMovementExtSensor ? 
    <ArmsMobile arms={arms.armMovement || arms.armMovementExtSensor} /> 
    : 
    <p style={{ textAlign: 'center'}}>Arms data not available!</p>
  );
}
